﻿<itp-panel>
    <list-legal-entities [clientId]="clientId"></list-legal-entities>
</itp-panel>